/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentDeliveryPlan } from 'app/shared/model/treatment-delivery-plan.model';
import { IRegimen } from 'app/shared/model/regimen.model';
import { ISequence } from 'app/shared/model/sequence.model';

export interface ITreatmentRegimen {
  id?: string;
  startDate?: number | null;
  endDate?: number | null;
  status?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  plan?: ITreatmentDeliveryPlan | null;
  regimen?: IRegimen | null;
  sequence?: ISequence | null;
}

export const defaultValue: Readonly<ITreatmentRegimen> = {
  active: false,
};
